import React from "react";
import SvgIcon from "../SvgIcon";

class DropdownIconsCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      selector: null,
      closed: false,
      current: null,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(e) {
    e.preventDefault();
    this.setState({ showMenu: !this.state.showMenu });
  }

  render() {
    const {
      title,
      items,
      action,
      classNames = "",
      classNamesPositions = "",
      alignRight,
    } = this.props;
    const unCheckedPath = "/img/svg/vuesax-linear-tick-square.svg";
    const checkedPath = "/img/svg/vuesax-linear-tick-square-checked.svg";
    return (
      <details
        id="dropdown-checklist"
        role="list"
        open={true}
        tabIndex="-1"
        className={classNames}
        data-align-right={alignRight ? true : undefined}
      >
        <summary
          aria-haspopup="listbox"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ showMenu: !this.state.showMenu });
          }}
          onBlur={(e) => {
            e.preventDefault();
            this.setState({ showMenu: false });
          }}
        >
          <span>
            {!this.state.selector
              ? title
              : items.find((i) => i.id === this.state.selector).title}
          </span>
          <SvgIcon
            src={
              this.state.showMenu
                ? "/img/svg/angle-up.svg"
                : "/img/svg/angle-down.svg"
            }
            alt="Sort"
          />
        </summary>
        <ul
          ref={(node) => (this.node = node)}
          className={this.state.showMenu ? `opened ${classNamesPositions}` : ""}
          role="listbox"
        >
          {items.map(({ title, alt, id }, i) => (
            <li
              key={i}
              onMouseDown={(e) => {
                action(id);
                this.setState({ selector: id, current: i });
              }}
            >
              <div>
                <SvgIcon
                  key={i}
                  alt={alt}
                  src={i === this.state.current ? checkedPath : unCheckedPath}
                  noFilterOnLight={i === this.state.current ? true : false}
                />
                {title}
              </div>
            </li>
          ))}
        </ul>
      </details>
    );
  }
}

export default DropdownIconsCheck;
